import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-vacancy-card',
  templateUrl: './vacancy-card.component.html',
  styleUrls: ['./vacancy-card.component.scss']
})
export class VacancyCardComponent implements OnInit {

  public img: string = '';
  public imgInstitution: string = '';
  public  apiUrl = environment.apiUrl;
  
  @Input() item: any;
  
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  typeName = {
    'Abierto': 'Abierto',
    'Cancelado': 'Cancelado',
    'Concluido': 'Concluido'
  }
  
    /*
    {
      title: item.courseName,
      duration: item.duration,
      userData: item.instructor,
      certification: item.certificate,
      type: item.courseType,
      start: item.start,
      institutionName: item?.institution,
      institutionImg: item?.institutionImage
    }
    */
  
    constructor() { }
  
    ngOnInit(): void {
      this.imgInstitution = (this.item.institutionImg) ? (`${this.apiUrl}${this.item.institutionImg}`):"";
      this.img = (this.item.userData?.image) ? (`${this.apiUrl}${this.item.userData.image}`):"";
    }

    public onClickItem(){
      this.onClick.emit(this.item);
    }
}
